<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate
        :columns="columns"
        :data="suppliers"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" :title="$t('pages_banners_index_178')">
      <Form ref="supplier" :model="supplier" :label-width="100">
        <Form-item :label="$t('pages_suppliers_index_1133')" prop="name">
          <Input type="text" v-model="supplier.name" placeholder="" />
        </Form-item>
        <Form-item :label="$t('pages_suppliers_index_1134')" prop="username">
          <Input type="text" v-model="supplier.username" />
        </Form-item>
        <Form-item :label="$t('pages_suppliers_index_1135')" prop="telephone">
          <Input type="text" v-model="supplier.telephone" placeholder="" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      modalShow: false,
      charge_modal: false,
      formType: '',
      price: 0,
      machoneCardId: '',
      rulesupplier: {
        name: [{ required: true, message: i18n.t('pages_suppliers_index_1133'), trigger: 'blur' }],
        username: [{ required: true, message: i18n.t('pages_suppliers_index_1134'), trigger: 'blur' }]
      },
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: i18n.t('pages_suppliers_index_1133'),
          key: 'name',
          width: 240,
          align: 'center'
        },
        {
          title: i18n.t('pages_suppliers_index_1134'),
          key: 'username',
          width: 140,
          align: 'center'
        },
        {
          title: i18n.t('pages_suppliers_index_1135'),
          key: 'telephone',
          width: 200,
          align: 'center'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at_str',
          align: 'center',
          width: 200
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          align: 'center',
          fixed: 'right',
          width: 200,
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.index()
  },
  computed: {
    ...mapGetters('supplier', ['supplier', 'suppliers', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('supplier', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('supplier', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page, query: this.query })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    handleSubmit () {
      if (this.formType === 'edit') {
        this.update(this.supplier)
      } else if (this.formType === 'new') {
        this.create(this.supplier)
      }
      this.modalShow = false
    }
  }
}
</script>
